<template>
    <div>
        <table class="table">
            <thead>
            <tr>
                <th class="mw-70">ID</th>
                <th>Data type</th>
                <th>Table Type</th>
                <th>Rewritable</th>
                <th>Events Tracking</th>
                <th>Timemodified Field</th>
                <th>Filter by Id</th>
                <th>Status</th>
                <th>Export</th>
                <th>Actions</th>
            </tr>
            </thead>
            <tbody>
                <tr v-for="(datatype, index) in datatypes" :key="datatype.id">
                    <td>{{ datatype.id }}</td>
                    <td>{{ datatype.datatype }}</td>
                    <td>{{ datatype.tabletype }}</td>
                    <td>{{ datatype.rewritable }}</td>
                    <td>{{ datatype.events_tracking }}</td>
                    <td>{{ datatype.timemodified_field }}</td>
                    <td>{{ datatype.filterbyid }}</td>
                    <td>{{ datatype.status }}</td>
                    <td>{{ datatype.exportenabled }}</td>
                    <td>
                        <admin-actions-dropdown>
                            <b-dropdown-item v-if="datatype.exportenabled == 'Enabled'" @click="resetDataType(datatype.datatype)">
                                Reset
                            </b-dropdown-item>
                            <b-dropdown-item :href="route('moodle.edit-datatypes-config', {'datatype': datatype.datatype, 'connection': connectionId})">
                                Edit
                            </b-dropdown-item>
                        </admin-actions-dropdown>
                    </td>
                </tr>

                <tr v-if="datatypes.length === 0">
                    <td class="table-empty" colspan="5">No Datatypes!</td>
                </tr>
            </tbody>
        </table>

        <loading-overlay :loading="loading"></loading-overlay>
    </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import route from "ziggy-js";

export default {
    props: {
        datatypeList: {
            type: String,
            default: ''
        },
        connectionId: {
            type: String
        },
        isMoodle: {
            type: String
        }
    },

    data() {
        return {
            datatypes: {},
            loading: false
        }
    },

    created() {
        this.renderList();
    },

    methods: {
        resetDataType(datatype) {
            if (!confirm('Are you sure want to reset table "' + datatype + '" in LMS?')) {
                return;
            }

            this.loading = true;
            return axios.post(this.route('moodle.reset-datatype', {connection: this.connectionId}), {
                    datatype: datatype
                })
                .then(response => {
                    if (response.status) {
                        this.$notifications.success('Table "' + datatype + '" reseted.');
                    } else {
                        this.$notifications.error('Table "' + datatype + '" not reseted.');
                    }
                    this.loading = false;
                })
        },

        renderList() {
            this.datatypes = this.datatypeList.length > 0
                ? JSON.parse(this.datatypeList)
                : {};
        },
        dateFormat(date) {
            return (date !=='0') ? moment.unix(date).format('DD MMM YYYY HH:mm:ss') : '-';
        }
    }
}
</script>
